import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CommonUtilityLib, UserPreferencesService } from '@thehubz/client/core';
import { Subscription } from 'rxjs';

@Component({
  selector: 'wl-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
})
export class LayoutComponent implements OnInit, OnDestroy {
  private headerTextSub?: Subscription;

  headline?: string;
  subHeadline?: { id: string; name: string };
  headerLink?: string;

  constructor(private router: Router, private commonUtilityLib: CommonUtilityLib, private userPreferencesService: UserPreferencesService) {}

  ngOnInit() {
    this.headerTextSub = this.commonUtilityLib.headerText$.subscribe((res) => {
      if (res) {
        this.headline = res.header;
        this.subHeadline = res.subHeader;
        this.headerLink = res.routeLinkPath;
      } else {
        this.headline = undefined;
        this.subHeadline = undefined;
        this.headerLink = undefined;
      }
    });
    this.userPreferencesService.createUserPreference(false);
  }

  ngOnDestroy(): void {
    this.headerTextSub?.unsubscribe();
  }

  loginRequest() {
    this.router.navigate(['/login']);
  }
}
